import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      // padding: "0px",
      background: "#F5F5F5",
    },
  },
  modalHeader: {
    padding: "13px 19px",
    "& .mantine-Modal-title": {
      flex: 1,
      textAlign: "center",
    },
  },
  contentBoxParent: {
    padding: "16px 24px",
  },
  contentBox: {
    padding: "30px 16px 12px 16px",
    borderRadius: "6px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    minHeight: 397,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 95,
    "& .infoText": {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: 14,
      textAlign: "center",
      width: "85%",
      fontWeight: 400,
    },
  },
  modalTitle: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    alignItems: "center",
    fontSize: 24,
    fontFamily: "Inter",
    color: "#000",
    fontWeight: 700,
    "& svg": {
      color: "#F04438",
    },
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      marginBottom: 8,
    },
    "& .mantine-Input-wrapper": {
      padding: "0px 12px",
      height: 48,
      borderRadius: 8,
      border: "1px solid #CBD5E1",
      background: "transparent",
      transition: "border-color 0.2s ease",

      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },

        "&:focus": {
          outline: "none",
        },
      },
    },
  },
  phoneLabel: {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#344054",
    marginBottom: 8,
  },

  

    pinInput: {
    fontFamily: "Inter",
  },

    login_btn: {
      "@media (max-width :48em)": {
        width: "100%",
      },
      "@media (max-width :800px)": {
        width: "100%",
      },
      background: "#000 ",
      width: "100%",
      height: rem(50),
      fontFamily: "Inter",
      fontSize: "22px",
      marginTop: 20,
      borderRadius: "4px",
      color: "#FFF",
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
      ":hover": {
        background: "#000",
        opacity: 0.8,
      },
    },
    resendLinkText: {
      marginTop: 15,
      '& .text':{
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Inter",
          color: "#737373",
      },
      "& .resendLink": {
        textDecoration: "none",
        fontSize: 14,
        fontWeight: 600,
        fontFamily: "Inter",
        color: "var(--app-primary)",
      },
      '& .chooseLink':{
        color: "#000"
      }
    },

  phoneInputWrapper: {
    width: "100%",
    border: "1px solid #CBD5E1",
    borderRadius: "8px",
    padding: "2px 0",
    alignItems: "center",

    "& button": {
      height: "2.625rem",
      border: "none",
    },
    "& input": {
      height: "2.625rem",
      border: "none",
    },

    "& .react-international-phone-country-selector": {
      border: "none !important",
      background: "transparent !important",
      height: "100%",
      padding: "0 0.5rem",
    },

    "& .react-international-phone-input": {
      flex: 1,
      border: "none !important",
      outline: "none !important",
      height: "100%",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      color: "#0F172A !important",
      fontFamily: "Inter !important",
    },
  },

  customokbutton: {
    background: "var(--app-primary)  !important",
    color: "var(--app-on-primary) !important",
    width: "440px !important",
    height: "44px !important",
    border: "1px solid var(--app-primary); !important",
    borderRadius: "8px !important",
    boxShadow: " 0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    padding: "8px 14px !important",
  },



}));

export default useStyles;
